module.exports = __webpack_public_path__ + "static/Vascepa_onegram_Bottle_Pill-5a013a41612dfb14b1ca3ce1e31782a6.jpg";